// extracted by mini-css-extract-plugin
export default {"toolbar":"StandardTable_toolbar__eBbP8","operations":"StandardTable_operations__uiTsJ","toolbarItem":"StandardTable_toolbarItem__-GAh1"};